module.exports = __webpack_public_path__ + "img/icon-caja-roja.3c54508b.svg";